module.exports = __webpack_public_path__ + "static/media/lens_rs.7dcc73bd.png";